import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import InstallationDeviceStatusRow from 'src/Libs/installation-status/components/InstallationDeviceStatusRow'
import { makeStyles } from 'tss-react/mui'
import { getInstallerName } from '../installation.functions'
import { Installation } from '../models/installation.model'
import { isFlowTheme } from 'src/Libs/utils'

const useStyles = makeStyles()(theme => ({
  collapsibleContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}))

interface Props {
  row: Installation
}

const PLACEHOLDER = '-'

const CollapsedColumnContent: React.FC<Props> = ({ row }) => {
  const { classes } = useStyles()
  const theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  const { t } = useCustomTranslation()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
      <Box className={classes.collapsibleContent}>
        <Typography variant="caption">{t('administration.installations.serialNumber')}</Typography>
        {row.emsMasterDeviceId ? <Typography variant="body2">{row.emsMasterDeviceId}</Typography> : PLACEHOLDER}
      </Box>
      {downMd && (
        <Box className={classes.collapsibleContent}>
          <Typography variant="caption">{t('installation.overview.installedBy')}</Typography>
          <Typography variant="body2">{getInstallerName(row)}</Typography>
        </Box>
      )}
      {downMd && !isFlowTheme && (
        <Box className={classes.collapsibleContent}>
          <Typography variant="caption">{t('installation.overview.status')}</Typography>
          <InstallationDeviceStatusRow installation={row} placeHolderUi={PLACEHOLDER} />
        </Box>
      )}
    </Box>
  )
}

export default CollapsedColumnContent
